<template>
  <div>
    <modal-photo
      v-if="showModalPhoto"
      :key="componentKeyModalPhoto"
      :user-id="userId"
      :token-auth="tokenAuth"
      :image="image"
      :photo="photo"
      :email="email"
      :phone="phone"
    />
    <div class="row">
      <div class="col-12 col-sm-12 col-md-2 col-lg-3 col-xl-3"></div>
      <div class="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="row" style="margin-bottom: 15px">
              <div
                v-if="loading"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <Skeletor :shimmer="true" height="120" width="120" pill />
              </div>
              <div
                style="position: relative"
                class="col-12 col-sm-12 col-md-12 col-xl-12 col-lg-12"
                align="center"
                v-else
              >
                <v-lazy-image
                  :src="photo"
                  class="rounded-circle img_profile"
                  style="border: 4px solid white; width: 100px"
                />

                <input
                  type="file"
                  id="upload"
                  ref="profilePhoto"
                  accept="image/jpeg, image/jpg, image/png"
                  @change="loadImage($event)"
                  hidden
                />
                <label for="upload" class="camera_photo">
                  <i style="margin: auto" class="fas fa-camera"></i
                ></label>
              </div>

              <div
                class="col-12 col-sm-12 col-md-12 col-xl-12 col-lg-12"
                align="center"
              >
                <p
                  style="
                    margin-bottom: 0px;
                    margin-top: 15px;
                    line-height: 18px;
                    text-align: center;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ displayName }}
                </p>
                <p
                  style="
                    margin-bottom: 15px;
                    text-align: center;
                    font-size: 13px;
                  "
                >
                  {{ dni }}
                </p>

                <form role="form" autocomplete="off" @submit.prevent="onSubmit">
                  <div class="col">
                    <div
                      class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                      style="margin-bottom: 10px; text-align: left"
                    >
                      <label
                        for="example-text-input"
                        class="form-control-label"
                        style="
                          font-weight: bold;
                          font-size: 12px;
                          text-align: left;
                        "
                        >Teléfono:</label
                      >
                      <Skeletor
                        v-if="loading"
                        :shimmer="true"
                        height="40"
                        width="100%"
                      />
                      <MazPhoneNumberInput
                        v-else
                        type="tel"
                        default-country-code="EC"
                        :country-locale="phoneCountryLocale"
                        :preferred-countries="preferredPhoneCountries"
                        style="
                          margin-bottom: 15px;
                          width: 100%;
                          box-sizing: border-box;
                        "
                        orientation="col"
                        no-example
                        required
                        show-code-on-list
                        countrySelectorWidth="90px"
                        block
                        :class="this.$store.state.darkMode ? 'dark' : ''"
                        :disabled="isDisabled"
                        :noValidationSuccess="isDisabled"
                        v-model="phone"
                        @update="handleUpdate"
                        :translations="{
                          countrySelector: {
                            placeholder: 'Código',
                            error: 'Elija un pais',
                          },
                          phoneInput: {
                            placeholder: 'Nro. celular',
                            example: 'Ejemplo:',
                          },
                        }"
                      />
                    </div>
                    <div
                      class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 w-100"
                    >
                      <Skeletor
                        v-if="loading"
                        :shimmer="true"
                        height="40"
                        width="100%"
                      />
                      <div
                        class="row justify-content-end"
                        style="padding-left: 16px; padding-right: 16px"
                        v-else
                      >
                        <div
                          v-if="isEdited"
                          class="row w-100 justify-content-end gap-1"
                        >
                          <button
                            id="btn_guardar"
                            type="submit"
                            class="btn btn-primary w-auto"
                            style="
                              margin-top: 15px;
                              padding-left: 16px;
                              padding-right: 16px;
                            "
                            :disabled="btnDisabled"
                          >
                            Guardar
                          </button>
                          <button
                            type="submit"
                            class="btn btn-cancel w-auto"
                            style="
                              margin-top: 15px;
                              padding-left: 16px;
                              padding-right: 16px;
                            "
                            @click="handleCancel"
                          >
                            Cancelar
                          </button>
                        </div>
                        <div
                          class="row w-100 justify-content-end"
                          v-else-if="!isEdited"
                        >
                          <button
                            type="button"
                            class="btn btn-primary w-auto"
                            style="
                              margin-top: 15px;
                              padding-left: 24px;
                              padding-right: 24px;
                            "
                            @click="handleIsEdited"
                          >
                            Editar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-2 col-lg-3 col-xl-3"></div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */

import ModalPhoto from "./ModalPhoto.vue";
import {
  PREFERRED_PHONE_COUNTRIES,
  PHONE_COUNTRY_LOCALE,
} from "@/constants/phoneCountries";
export default {
  name: "EdicionPerfil",
  components: {
    ModalPhoto,
  },
  data() {
    let datos = JSON.parse(localStorage.getItem("userData"));
    let optionsGeneros = [
      { id: "Masculino", value: "Masculino" },
      { id: "Femenino", value: "Femenino" },
      { id: "Transgenero", value: "Transgénero" },
    ];

    let optionsEstadoCivil = [
      { id: "Soltero/a", value: "Soltero/a" },
      { id: "Divorciado/a", value: "Divorciado/a" },
      { id: "Casado/a", value: "Casado/a" },
      { id: "Viuda/o", value: "Viuda/o" },
    ];

    let photo = "";

    if (datos.photoURL === "") {
      photo = "/img/user.svg";
    } else {
      photo = datos.photoURL;
    }

    return {
      phoneCountryLocale: PHONE_COUNTRY_LOCALE,
      preferredPhoneCountries: PREFERRED_PHONE_COUNTRIES,
      originalData: {
        email: datos.email,
        phone: datos.phone,
        photo: datos.photoURL, // other fields...
      },
      userId: datos.userId,
      tokenAuth: datos.tokenAuth,
      permitirEmail: false,
      dni: datos.dni,
      displayName: datos.displayName,
      photo: datos.photoURL,
      ciudad: "",
      showModalPhoto: false,
      optionsGeneros: optionsGeneros,
      optionsEstadoCivil: optionsEstadoCivil,
      genero: "",
      loading: false,
      estadoCivil: "",
      isDisabled: true,
      email: datos.email,
      phone: datos.phone,
      componentKeyModalPhoto: 100,
      type: "",
      image: {
        src: null,
        type: null,
      },
      results: {},
      isEdited: false,
    };
  },
  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("inactiveShowMenu");
    }
  },
  methods: {
    handleIsEdited() {
      this.isEdited = !this.isEdited;
      this.isDisabled = !this.isDisabled;
    },
    handleCancel() {
      this.isEdited = !this.isEdited;
      this.isDisabled = !this.isDisabled;
      this.photo = this.originalData.photo;
      this.phone = this.originalData.phone;
      this.email = this.originalData.email;
    },
    handleUpdate(event) {
      this.results = event;
      if (event?.isValid && event?.e164) {
        this.phone = event.e164;
      }
    },
    getProfile() {
      this.loading = true;

      this.$https
        .post("/login/getProfile/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.photo = response.data.photoURL;
            this.phone = response.data.phone;
            let datos = JSON.parse(localStorage.getItem("userData"));
            localStorage.setItem(
              "userData",
              JSON.stringify({
                ...datos,
                phone: response.data.phone,
                photoURL: response.data.photoURL,
              })
            );
            this.loading = false;
          } else {
            if (response.data.code == 401) {
              localStorage.removeItem("userData");
              this.$store.state.user = "";

              // Redirect to login page
              this.$router.push({ name: "login" });
            } else {
              // this.getProfile();
            }
          }
        })
        .catch((error) => {
          // this.getProfile();
        });
    },
    onChange2(event) {
      this.genero = event.target.value;
    },

    onChange1(event) {
      this.estadoCivil = event.target.value;
    },

    onSubmit(event) {
      event.preventDefault();
      this.isDisabled = true;

      document.getElementById("btn_guardar").innerHTML =
        '<i class="fas fa-circle-notch fa-spin"></i> Guardando...';

      this.$https
        .post(
          "/login/updateProfile",
          {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            phone: this.phone,
            photo: this.photo,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.tokenAuth}`, // Replace `yourAuthToken` with your actual token
              // Add other headers here as needed
            },
          }
        )
        .then((response) => {
          document.getElementById("btn_guardar").innerHTML = "Guardar";
          if (response.data.code == 200) {
            this.$toast.success("Perfil actualizado exitosamente", {
              position: "top-right",
              max: 10,
            });
            this.isDisabled = true;
            this.isEdited = false;
            // this.getProfile();
          } else {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });

            if (response.data.code == 401) {
              localStorage.removeItem("userData");
              this.$store.state.user = "";

              // Redirect to login page
              this.$router.push({ name: "Signin" });
            }
          }
        })
        .catch((error) => {
          this.$toast.error(error, {
            position: "top-right",
            max: 10,
          });
        });
    },
    loadImage(event) {
      const file = event.target.files[0];

      if (!file) return;

      // Allow both JPEG and PNG
      const validTypes = ["image/jpeg", "image/png"];

      if (!validTypes.includes(file.type)) {
        this.resetInputWithError(
          "El archivo debe tener una extensión JPG, JPEG o PNG"
        );
        return;
      }

      const fileSizeInMB = file.size / 1024 / 1024;

      if (fileSizeInMB > 5) {
        this.resetInputWithError("La imagen debe pesar menos de 5mb");
        return;
      }

      // Proceed with valid image
      this.type = file.type;
      const blob = URL.createObjectURL(file);

      // Revoke the old object URL to free up memory
      if (this.image.src) {
        URL.revokeObjectURL(this.image.src);
      }

      this.image = {
        src: blob,
        type: this.type,
      };

      this.showModalPhoto = true;
    },
    resetInputWithError(errorMessage) {
      // Check if the profilePhoto reference is available before accessing it
      if (this.$refs.profilePhoto) {
        this.$refs.profilePhoto.value = null; // Clear the input value
      } else {
        console.warn("Profile photo input reference is not available.");
      }

      this.$toast.error(errorMessage, {
        position: "bottom-right",
        max: 10,
      });
    },

    resetModalPhoto() {
      this.$refs.profilePhoto.value = null;
      this.componentKeyModalPhoto += 1;
      this.showModalPhoto = false;
    },
    updateProfilePhoto(url) {
      this.photo = url; // Update local photo variable
      this.originalData.photo = url; // Update original data
      // Optionally update local storage if necessary
      let datos = JSON.parse(localStorage.getItem("userData"));
      localStorage.setItem(
        "userData",
        JSON.stringify({
          ...datos,
          photoURL: url,
        })
      );
    },

    fetchProfile(data) {
      this.photo = data.photoURL;
      this.phone = data.phone;
    },
  },
  mounted() {
    this.getProfile();

    this.$eventBus.on("reiniciarModalPhoto", this.resetModalPhoto);
    this.$eventBus.on("updateFotoPerfil", this.updateProfilePhoto);
    this.$eventBus.on("fetchProfile", this.fetchProfile);
  },
  beforeUnmount() {
    this.$eventBus.off("reiniciarModalPhoto", this.resetModalPhoto);
    this.$eventBus.off("updateFotoPerfil", this.updateProfilePhoto);
    this.$eventBus.off("fetchProfile", this.fetchProfile);
  },
  computed: {
    btnDisabled() {
      return this.isDisabled || !this.results.isValid;
    },
  },
  watch: {},
};
</script>

<style>
/* Add this CSS to your stylesheet */

/* .m-input-label.--is-disabled {
  color: white !important;
}
.m-input-label {
  color: white !important;
} */

/* .m-input.--is-disabled .m-input-wrapper[data-v-bec4f39d] */
</style>
